import { backUpIfDue } from '@/app/backup/schedule';
import type { Note } from '@/app/db/repo';
import { useEffect } from 'react';

// how often an open app looks whether a backup is due
const CHECK_EVERY_MS = 60 * 60 * 1000;

// A backup goes out once a day while the app is open somewhere, where it's
// turned on (../backup/schedule.ts); one that fails is tried again at the
// next check.
export const useDailyBackup = (notes: () => Promise<Note[]>) => {
  useEffect(() => {
    const check = () =>
      backUpIfDue(notes)
        .then(status => {
          if (status && !status.ok) console.error('backup', status.error);
        })
        .catch(e => console.error('backup', e));
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    check();
    const interval = setInterval(check, CHECK_EVERY_MS);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [notes]);
};
